import React, { useEffect, useState, memo } from 'react'
import { useTranslation } from 'react-i18next'
import CorrectAnswer from '../../assets/correct_answer.svg'
import information from '../../assets/informationIcon.svg'
import WrongAnswer from '../../assets/wrong_answer.svg'
import InstructionsModal from '../InstructionsModal/InstructionsModal'
import { answerKeyByLang, solutionKeyByLang } from '../../constants/langTypes'
import Mathjax from 'components/Mathjax'

import './SingleChoiceMultipleChoiceAnswer.css'

const SingleChoiceMultipleChoiceAnswer = (props) => {
    const { t, i18n } = useTranslation()
    const [isCorrectAnswer, setIsCorrectAnswer] = useState(false)
    const [show, setShow] = useState(false)
    const [currentLng, setCurrentLng] = useState('en')

    useEffect(() => {
        setCurrentLng(i18n.language)
        if (props.mock) {
            props.data.question.english_answer.choices?.map((data, i) => {
                if (
                    data.is_answer &&
                    props.data.question.answerbyUser[0] == data.choiceId
                )
                    setIsCorrectAnswer(true)
            })
        }
    }, [i18n.language])

    const handleModal = () => {
        setShow(!show)
    }

    return (
        <div className="multiple-choice-answer-container">
            <article style={{ display: 'flex', justifyContent: 'space-between' }}>
                <span className="ans-description">
                    {t('Only one correct answer')}
                </span>
                {props.mock ? (
                    <span className="difficulty-level">
                        {t(
                            props.data.question.lod == 'E'
                                ? 'Easy'
                                : props.data.question.lod == 'M'
                                ? 'Medium'
                                : 'Difficult',
                        )}
                    </span>
                ) : null}
                {!props.mock && (
                    <span style={{ marginBottom: '14px', marginTop: '45px' }}>
                        <img
                            src={information}
                            onClick={handleModal}
                            style={{
                                height: '17px',
                                width: '17px',
                                cursor: 'pointer',
                            }}
                        />
                    </span>
                )}
            </article>
            {show ? <InstructionsModal show={show} single={true} /> : ''}
            <fieldset className="multiple-choice-answer">
                {props.data.question[answerKeyByLang[currentLng]]?.choices?.map(
                    (data, i) => {
                        return (
                            <div className="option-wrapper" key={data?.choiceId}>
                                {/* <span>{data.choiceId}</span> */}
                                {props.mock && data.is_answer ? (
                                    <div
                                        style={{
                                            textAlign: `${
                                                props.data.question
                                                    .answerbyUser[0] == data.choiceId
                                                    ? 'start'
                                                    : 'end'
                                            }`,
                                            color: '#2dce89',
                                            fontSize: '15px',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {' '}
                                        <img
                                            style={{ marginRight: '5px' }}
                                            src={CorrectAnswer}
                                        />
                                        {t(
                                            props.data.question.answerbyUser[0] ==
                                                data.choiceId
                                                ? 'Your Answer'
                                                : 'Correct Answer',
                                        )}
                                    </div>
                                ) : null}
                                {props.mock && data.is_answer == false ? (
                                    <div
                                        style={{
                                            textAlign: `${
                                                props.data.question
                                                    .answerbyUser[0] == data.choiceId
                                                    ? 'start'
                                                    : 'end'
                                            }`,
                                            color: '#f5365c',
                                            fontSize: '15px',
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        {props.data.question.answerbyUser[0] ==
                                        data.choiceId ? (
                                            <img
                                                style={{ marginRight: '5px' }}
                                                src={WrongAnswer}
                                            />
                                        ) : null}
                                        {t(
                                            props.data.question.answerbyUser[0] ==
                                                data.choiceId
                                                ? 'Your Answer'
                                                : null,
                                        )}
                                    </div>
                                ) : null}
                                <div
                                    className={
                                        props.mock
                                            ? data.is_answer
                                                ? 'mockoption selected'
                                                : props.data.question
                                                      .answerbyUser[0] ==
                                                  data.choiceId
                                                ? 'mockoption2 selected'
                                                : 'mockoption2'
                                            : props.isPreview && data.is_answer
                                            ? 'option correct'
                                            : props.data.question.answerbyUser ==
                                              data.choiceId
                                            ? 'option selected'
                                            : 'option'
                                    }
                                    onClick={() =>
                                        props.mock
                                            ? null
                                            : props.onClick(
                                                  data.choiceId,
                                                  props.data,
                                              )
                                    }
                                >
                                    <span className="option-choice-id">
                                        {data.choiceId}.
                                    </span>

                                    <div role="option">
                                        <Mathjax
                                            html={props.getAppendImgUrl(
                                                `<p>${data.text}</p>`,
                                            )}
                                        />
                                    </div>
                                </div>
                            </div>
                        )
                    },
                )}
                {props.mock ? (
                    <>
                        <div
                            style={{
                                textAlign: 'center',
                                margin: '20px 0px',
                                fontSize: '16px',
                            }}
                        >
                            {props.data.question.answerbyUser.length ? (
                                !isCorrectAnswer ? (
                                    <>
                                        <div
                                            style={{
                                                color: '#f5365c',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {t('Your answer is incorrect!')}
                                        </div>
                                        {/*<div style={{ color: "#a1aeb7", fontWeight: 500 }}>*/}
                                        {/*  Try again*/}
                                        {/*</div>*/}
                                    </>
                                ) : (
                                    <>
                                        <div
                                            style={{
                                                color: '#2dce89',
                                                fontWeight: 'bold',
                                            }}
                                        >
                                            {t('Your answer is correct!')}
                                        </div>
                                        <div
                                            style={{
                                                color: '#a1aeb7',
                                                fontWeight: 500,
                                            }}
                                        >
                                            {t('Well done here is the solution')}
                                        </div>
                                    </>
                                )
                            ) : null}
                        </div>
                        <div
                            style={{
                                border: '1px solid #00b0f5',
                                justifyContent: 'center',
                                padding: '25px',
                                borderRadius: '10px',
                                overflow: 'auto',
                            }}
                        >
                            <div
                                style={{
                                    fontSize: '20px',
                                    fontWeight: 'bold',
                                    color: '#00b0f5',
                                }}
                            >
                                {t('Solution')}
                            </div>
                            <Mathjax
                                html={props.getAppendImgUrl(
                                    `<p>${
                                        props.data.question[
                                            solutionKeyByLang[currentLng]
                                        ]
                                    }</p>`,
                                )}
                            />
                        </div>
                    </>
                ) : null}
            </fieldset>
        </div>
    )
}

export default memo(SingleChoiceMultipleChoiceAnswer)
